import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { login, setErrorMessage } from "../../features/auth/authSlice";
import Button from "../../components/shared/Button";
import { Link, useNavigate } from "react-router-dom";
import loginTruck from "../../images/img/login-truck.jpg";
import MailInput from "../../components/shared/input/giris/MailInput";
import PasswordInput from "../../components/shared/input/giris/PasswordInput";
import * as FaIcons from "react-icons/fa6";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import { toast } from "react-toastify";
import { consumeSessionExpiryMessage } from "../../utils/auth/sessionExpiry";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  .login-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    @media (max-width: 992px) {
      flex-direction: column;
    }

    .left {
      height: 100%;
      width: 50%;
      @media (max-width: 992px) {
        display: none;
      }
      .imageBox {
        height: 100%;
        width: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }

    .right {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin: 0 auto;
      flex-direction: column;
      @media (max-width: 992px) {
        width: 100%;
      }

      h1 {
        margin-bottom: 40px;
        font-size: 18px;
        font-weight: 600;
        line-height: 16px;
      }
      .form {
        width: 500px;
        & > div {
          margin-block: 15px;
        }
        @media (max-width: 1200px) {
          width: 70%;
        }
      }
      .mid {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .remember {
          display: flex;
          align-items: center;

          .checkbox {
            .show-icon {
              width: 20px;
              cursor: pointer;
              height: 20px;
              border: 1px solid black;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .none {
              cursor: pointer;
              width: 20px;
              height: 20px;
              border: 1px solid black;
              border-radius: 2px;
            }
          }
          p {
            font-size: 14px;
            font-weight: 500;
            line-height: 11px;
            margin-left: 10px;
          }
          input {
            width: 15px;
            height: 15px;
            color: var(--color-dark);
            background-color: var(--color-dark);
          }
        }
      }

      .button-container {
        display: flex;
        flex-direction: column;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;
          padding: 10px 5px;
          width: 100%;
          border-radius: 5px;
          height: 36px;
          background-color: var(--color-main);
          color: #fff;
          font-family: Raleway;
          font-size: 14px;
          font-weight: 500;
          line-height: 16px;
        }
      }
    }
    .message-container{
      font-size: var(--font-size-sm);
      color: var(--color-main);
    }
  }
`;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });

  const [isShow, setIsShow] = useState(false);

  const [rememberMe, setRememberMe] = useState(false);

  const { token, isError, message, isLoadingLogin } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token, navigate]);

  useEffect(() => {
    dispatch(setErrorMessage(null))

    const sessionExpiryMessage = consumeSessionExpiryMessage();
    if (sessionExpiryMessage) {
      toast.error(sessionExpiryMessage, { toastId: "session-expired" });
    }
  }, [])

  const handleChange = (e) => {
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(login({loginData: userData, isFromRegister: false, isRemember: rememberMe}));
  };

  const passwordShow = () => {
    setIsShow((show) => !show);
  };

  const RememberClick = () => {
    setRememberMe((remember) => !remember);
  };

  return (
    <Container>
      <div className="login-container">
        <div className="left">
          <div className="imageBox">
            <img src={loginTruck} alt="login-truck" />
          </div>
        </div>

        <div className="right">
          <h1>Kamyoon'a Giriş Yapın</h1>
          <form className="form" onSubmit={handleSubmit}>
            <MailInput
              handleChange={handleChange}
              value={userData.email}
              width={""}
              type={"email"}
              labelText={"Mail Adresi"}
              name={"email"}
            />
            <PasswordInput
              isShow={isShow}
              onClick={passwordShow}
              handleChange={handleChange}
              value={userData.password}
              width={""}
              type={"password"}
              labelText={"Şifre"}
              name={"password"}
            />

            {message && (
              <div className="message-container">
                <p>{message}</p>
              </div>
            )}

            <div className="mid">
              <div className="remember">
                <div className="checkbox">
                  {rememberMe ? (
                    <div onClick={RememberClick} className="show-icon">
                      <FaIcons.FaCheck />
                    </div>
                  ) : (
                    <div onClick={RememberClick} className="none"></div>
                  )}
                </div>
                <p>Beni Hatırla</p>
              </div>
              <Link to={"/sifremi-unuttum"} className="forget-password-text">
                Şifremi Unuttum
              </Link>
            </div>

            

            <div className="button-container">
               <button className="submit-btn" type="submit">{isLoadingLogin ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Giriş Yap"}</button>
              <Button
                type="text"
                text={"Kayıt Ol"}
                handleClick={() => navigate("/kayit-ol")}
                color={"#FFF"}
              />
            </div>

           
           
          </form>
        </div>
      </div>
    </Container>
  );
};

export default Login;
